module.exports = __webpack_public_path__ + "img/cj-reject-pic.5323124b.png";